




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import RoutView from '@/layouts/RouteView';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';

import { Store } from 'vuex';
import AppModel from '@/store/modules/app';

import App from '../../App.vue';

@Component({ components: { RoutView } })
export default class MainLayoutComponent extends Vue {
  @State(s => s.app.multiTab) multiTab?: boolean;
  onClickLeft() {
    if (window.history.length <= 1) {
      this.$router.push({ name: 'home' });
      return false;
    } else {
      this.$router.go(-1);
    }

    // this.$router.push({
    //   name: 'home',
    // });
  }

  goHome() {
    this.$router.push({ name: 'home' });
  }
  // 是否可收缩
  get getCollapsed(): boolean {
    return AppModel.collapsed;
  }
  // 距离顶部是否大于120px
  get getScrollTop(): boolean {
    return AppModel.isScrollTop;
  }

  mounted() {
    // 监听页面大小变化
    window.addEventListener('resize', this.throttle(this.handleFixContent, 100));
    window.addEventListener('scroll', this.throttle(this.handleFixSider, 100));
  }

  /** 自适应内容布局 */
  handleFixContent() {
    const fullWidth = document.documentElement.clientWidth;
    if (fullWidth < 1200) {
      AppModel.setCOLLAPSED(true);
    } else {
      AppModel.setCOLLAPSED(false);
    }
  }
  handleFixSider() {
    const top = document.documentElement.scrollTop;
    if (top >= 120) {
      AppModel.setScrollTop(true);
    } else {
      AppModel.setScrollTop(false);
    }
  }
  /** 节流函数 限制函数的执行次数，控制一定时间内只执行一次。 */
  throttle(fn: any, rateTime: number) {
    let timer: any = null;
    return (...args: any[]) => {
      if (!timer) {
        timer = setTimeout(() => {
          fn.apply(this, args);
          timer = null;
        }, rateTime);
      }
    };
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleFixContent);
    window.removeEventListener('resize', this.handleFixSider);
  }

  get contentCss() {
    return {
      margin: this.$route.meta.hiddenPageHeader === true ? '0' : '10px',
      'margin-left': this.$route.meta.hiddenPageHeader === true ? '1px' : '10px',
      'background-color': 'white',
      'border-radius': '3px',
    };
  }
}
